import * as React from "react"
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import {fontFaceMoontime,headStyle,bgStyle,fontWhite} from './mckCares.module.scss'
import {hoverTitle,hoverTitleWrap,center} from './shared.module.scss'

const Neighborhood = ({favSpots,neighborhoodText})=>{

    let images = [];
    if(favSpots){
      favSpots.map((i)=>{
          images.push({'img':getImage(i),'title':i.title,'link':i.description});
      });
    }
    const mapInSlices = (array, sliceSize, sliceFunc)=> {
      const out = [];
      for (var i = 0; i < array.length; i += sliceSize) {
        const slice = array.slice(i, i + sliceSize);
        out.push(sliceFunc(slice, i));
      }
      return out;
    }
    return(
        <section className={bgStyle}>
            <br />
            <br />
            <div className=" container">
                <div className="columns is-vcentered is-mobile is-multiline is-padded">
                    <div className="column is-full-mobile">
                        <h1 className={fontFaceMoontime+' '+headStyle+' '+center} >Best of the Neighborhood </h1>
                        <p className={fontWhite+' '+center}>{neighborhoodText}</p>
                    </div>
                </div>
                        <br />
                    {mapInSlices(images,5,(image, sliceIndex)=>(
                        <div key={sliceIndex} className="columns">
                          {image.map((img, index)=>{
                            return (
                                <div key={index} className={hoverTitleWrap+" column is-one-fifth"} 
                                >
                                <GatsbyImage image={img.img} alt={img.title} style={{minHeight:'250px'}}/>
                                <p className={hoverTitle} style={{width:'91.3%'}}>{img.title}</p>
                                </div>
                            )
                          })}
                        </div>
                    ))}
            </div>
            <br />
            <br />
        </section>
    )
}


export default Neighborhood
